export function getAggregatedEvents(events) {
    var aggEvents = [];
    if (events) {
        var _loop_1 = function (event_1) {
            if (aggEvents.length === 0) {
                aggEvents.push([event_1]);
            }
            else {
                var assigned = false;
                for (var i = aggEvents.length - 1; i >= 0; i--) {
                    var aggEvent = aggEvents[i];
                    var timeDiff = event_1.time - aggEvent[aggEvent.length - 1].time;
                    var dists = aggEvent.map(function (e) { return Math.sqrt(Math.pow(event_1.x - e.x, 2) + Math.pow(event_1.z - e.z, 2)); });
                    var dist = Math.min.apply(Math, dists);
                    if (dist < 3500 && timeDiff < 25) {
                        aggEvent.push(event_1);
                        assigned = true;
                        break;
                    }
                }
                if (!assigned) {
                    aggEvents.push([event_1]);
                }
            }
        };
        for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
            var event_1 = events_1[_i];
            _loop_1(event_1);
        }
    }
    return aggEvents;
}
export function getWinrateContributions(aggEvents, allyRoles, playerTeam) {
    var winrateContributions = Object.values(allyRoles).reduce(function (acc, championName) {
        acc[championName] = { overall: 0, gameImpact: 0, deaths: 0 };
        return acc;
    }, {});
    aggEvents.forEach(function (event) {
        return event.forEach(function (_a) {
            var participantChampionNames = _a.participantChampionNames, participantTeam = _a.participantTeam, victimName = _a.victimName, victimTeam = _a.victimTeam, winrateDiff = _a.winrateDiff;
            participantChampionNames.forEach(function (championName) {
                if (championName in winrateContributions && participantTeam === playerTeam) {
                    winrateContributions[championName].overall += winrateDiff;
                    winrateContributions[championName].gameImpact += winrateDiff;
                }
            });
            if (victimName in winrateContributions && victimTeam === playerTeam) {
                winrateContributions[victimName].overall += winrateDiff;
                winrateContributions[victimName].deaths += winrateDiff;
            }
        });
    });
    return winrateContributions;
}
export function getRanks(winrateContributions, playerChampion) {
    var getPlayerRank = function (winrateContributions, category) {
        winrateContributions = Object.entries(winrateContributions);
        winrateContributions.sort(function (_a, _b) {
            var a = _a[1];
            var b = _b[1];
            return b[category] - a[category];
        });
        var rank = 1;
        var prevContribution = null;
        var tiedCount = 0;
        for (var _i = 0, winrateContributions_1 = winrateContributions; _i < winrateContributions_1.length; _i++) {
            var _a = winrateContributions_1[_i], championName = _a[0], contribution = _a[1];
            if (prevContribution !== null && contribution[category] < prevContribution) {
                rank += tiedCount + 1;
                tiedCount = 0;
            }
            else if (prevContribution !== null && contribution[category] === prevContribution) {
                tiedCount++;
            }
            else {
                tiedCount = 0;
            }
            if (championName === playerChampion) {
                return rank;
            }
            prevContribution = contribution[category];
        }
    };
    var playerRanks = Object.keys(winrateContributions[playerChampion]).reduce(function (acc, category) {
        acc[category] = getPlayerRank(winrateContributions, category);
        return acc;
    }, {});
    return playerRanks;
}
export function formatWinrate(winrate) {
    if (winrate === undefined) {
        return '-';
    }
    return winrate.toFixed(1);
}
export function getWinrateColor(winrate) {
    if (winrate === undefined) {
        return 'gray';
    }
    if (winrate < 50) {
        var hue = 0;
        return "hsl(".concat(hue, ", ").concat(100 - 2 * winrate, "%, ").concat(75 - 0.5 * (50 - winrate), "%)");
    }
    else {
        var hue = 120;
        return "hsl(".concat(hue, ", ").concat(2 * (winrate - 50), "%, ").concat(75 - 0.5 * (winrate - 50), "%)");
    }
}
export function formatWinrateDiff(diff) {
    if (diff === undefined) {
        return '-';
    }
    return (diff >= 0 ? '+' : '') + diff.toFixed(1);
}
export function getWinrateDiffColor(diff) {
    if (diff === undefined) {
        return 'gray';
    }
    var normalizedDiff = Math.max(-10, Math.min(10, diff));
    var hue = (normalizedDiff + 10) * 6;
    var saturation = Math.abs(normalizedDiff) * (100 / 10);
    var lightness = 75 - Math.abs(normalizedDiff) * (15 / 10);
    return "hsl(".concat(hue, ", ").concat(saturation, "%, ").concat(lightness, "%)");
}
